var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-div"},[_c('van-loading',{attrs:{"vertical":""}},[_vm._v("请求中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }